module.exports = __webpack_public_path__ + "static/img/logoReport.db5edcbc.png";